import React from 'react';

export default function PaperIcon() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4998 21H2.49984C2.27882 21 2.06686 20.9122 1.91058 20.7559C1.7543 20.5996 1.6665 20.3877 1.6665 20.1667V1.83333C1.6665 1.61232 1.7543 1.40036 1.91058 1.24408C2.06686 1.0878 2.27882 1 2.49984 1H12.4998L18.3332 6.83333V20.1667C18.3332 20.3877 18.2454 20.5996 18.0891 20.7559C17.9328 20.9122 17.7209 21 17.4998 21Z"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 1V6.83333H18.3333"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6665 11.8333H13.3332"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6665 15.1667H13.3332"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
